if (!customElements.get("m-image-grid-slider")) {
  class MImageGridSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.initMobileSlider();
      this.handleResize();
    }

    initMobileSlider() {
      // Solo inicializar en mobile
      if (window.innerWidth >= 768) return;

      const slideContainer = this.querySelector(".swiper-container");
      if (!slideContainer) return;

      const autoplay = this.dataset.autoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed || 5;
      const showNav = this.dataset.showNav === "true";
      
      if (typeof MinimogLibs !== 'undefined' && MinimogLibs.Swiper) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          spaceBetween: 0,
          autoplay: autoplay ? {
            delay: parseInt(autoplaySpeed) * 1000,
            disableOnInteraction: false,
          } : false,
          loop: true,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          navigation: showNav ? {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          } : false,
        });
      }
    }

    handleResize() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const isMobile = window.innerWidth < 768;
          
          // Destruir slider si estamos en desktop
          if (!isMobile && this.slider) {
            this.slider.destroy(true, true);
            this.slider = null;
          }
          
          // Inicializar slider si estamos en mobile y no existe
          if (isMobile && !this.slider) {
            this.initMobileSlider();
          }
        }, 250);
      });
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy(true, true);
      }
    }
  }

  customElements.define("m-image-grid-slider", MImageGridSlider);
}